import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SelectFilterOption } from '@klickdata/core/table';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-notes-listing-sheet',
    templateUrl: './notes-listing-sheet.component.html',
    styleUrls: ['./notes-listing-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesListingSheetComponent implements OnInit {
    public noteVisibilityOptions: SelectFilterOption[];
    constructor(
        public bottomSheetRef: MatBottomSheetRef<NotesListingSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    ) {
        this.noteVisibilityOptions = Utils.getNotesVisibilityOptions();
    }

    ngOnInit(): void {}
}
